import { RouteProps } from "react-router-dom";
import Home from "../../../pages/Home/Home";
import React from "react";
import { LearnPage } from "../../../pages/LearnPage/LearnPage";
import Profile from "../../../pages/Profile/Profile";
import MyStudying from "../../../pages/MyStudying/MyStudying";
import Panel from "../../../pages/Panel/Panel";
import CoursePage from "../../../pages/Course/CoursePage";
import Search from "../../../pages/Search/Search";
import { NotFoundPage } from "../../../pages/NotFoundPage";
import { LearnDashboard } from "../../../pages/LearnDashboardPreview/LearnDashboard";
import { ConstructorCourse } from "../../../pages/Panel/components/constructor/ConstructorCourse/ConstructorCourse";

export enum AppRoutes {
  MAIN = "main",
  PROFILE = "profile",
  STUDYING = "studying",
  COURSE = "course",

  // Course learn
  PANEL = "panel",
  COURSE_LEARN = "course_learn",
  COURSE_LEARN_PREVIEW = "course_learn_preview",

  CONSTUCTOR = "constructor",
  NOT_FOUND = "not_found",
  SEARCH = "search",
}

export const RoutePath: Record<AppRoutes, string> = {
  [AppRoutes.MAIN]: "/",
  [AppRoutes.PROFILE]: "/profile",
  [AppRoutes.STUDYING]: "/studying",
  [AppRoutes.PANEL]: "/panel",
  [AppRoutes.COURSE]: "/course/:courseId",

  // Course learn
  [AppRoutes.COURSE_LEARN]: "/course/learn/:courseId/:studentId",
  [AppRoutes.COURSE_LEARN_PREVIEW]: "/course/learn/preview/:courseId",

  [AppRoutes.CONSTUCTOR]: "/panel/constructor/:courseId",
  [AppRoutes.SEARCH]: "/search/:categoryId?",
  [AppRoutes.NOT_FOUND]: "*",
};

export const routeConfig: Record<AppRoutes, RouteProps> = {
  [AppRoutes.MAIN]: {
    path: RoutePath.main,
    element: <Home />,
  },
  [AppRoutes.PROFILE]: {
    path: RoutePath.profile,
    element: <Profile />,
  },
  [AppRoutes.STUDYING]: {
    path: RoutePath.studying,
    element: <MyStudying />,
  },
  [AppRoutes.PANEL]: {
    path: RoutePath.panel,
    element: <Panel />,
  },
  [AppRoutes.COURSE]: {
    path: RoutePath.course,
    element: <CoursePage />,
  },
  [AppRoutes.COURSE_LEARN]: {
    path: RoutePath.course_learn,
    element: <LearnPage />,
  },
  [AppRoutes.COURSE_LEARN_PREVIEW]: {
    path: RoutePath.course_learn_preview,
    element: <LearnDashboard />,
  },
  [AppRoutes.CONSTUCTOR]: {
    path: RoutePath.constructor,
    element: <ConstructorCourse />,
  },
  [AppRoutes.NOT_FOUND]: {
    path: RoutePath.not_found,
    element: <NotFoundPage />,
  },
  [AppRoutes.SEARCH]: {
    path: RoutePath.search,
    element: <Search />,
  },
};
